module.exports = {"id":"234986","name":"Panagiotis Retsos","rating":"73","photo":"./data/images/photos/3/234986.png","club":{"name":"Bayer 04","logo":"./data/images/clubs/Bayer04.png"},"positions":["DC","DD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PanagiotisRetsos0.json
// module id = 3360
// module chunks = 0